let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3bG8M")).then(() => parcelRequire('dPYKb'));